import { ComponentProps, useCallback, useEffect } from 'react'
import {
  selectActionsLimit,
  selectLastActions,
  setActions as setActionsAction,
  setActionsLimit as setActionsLimitAction,
} from 'react-common'
import { HeaderActionsItem, Header as UiKitHeader } from '@platform/ui'
import { useAppDispatch, useAppSelector } from '@/store/hooks'

type Actions = ComponentProps<typeof UiKitHeader.Actions>['items']

export function useHeaderActions() {
  const dispatch = useAppDispatch()
  const headerActions = useAppSelector(selectLastActions)
  const actionsLimit = useAppSelector(selectActionsLimit)

  const setActions = useCallback(
    (actions: Omit<HeaderActionsItem, 'key'>[]) => {
      const actionsItems = actions.map((_, i) => ({ ..._, key: i }))

      dispatch(setActionsAction([actionsItems]))
    },
    [dispatch],
  )

  const setActionsLimit = useCallback(
    (limit: number) => {
      dispatch(setActionsLimitAction(limit))
    },
    [dispatch],
  )

  useEffect(() => {
    return () => {
      setActions([])
      setActionsLimit(2)
    }
  }, [setActions, setActionsLimit])

  return {
    actions: headerActions as Actions,
    limit: actionsLimit,
    setActions,
    setActionsLimit,
  }
}
